import { Cross } from '@creditornot/cb-icons';
import { colors, cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { useLocalStorage } from 'common/hooks';
import { MOBILE_BREAKPOINT, useIsMobile } from 'common/hooks/useIsMobile';
import { Typography } from 'common/typography';

import Banner from '../images/Banner.png';
import BannerMobile from '../images/BannerMobile.png';

const HeroHeaderContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 48px;
  align-self: stretch;
  background-color: ${colors.wolt8};
  border-radius: 8px;
  position: relative;
  align-items: flex-end;

  @media (width < ${MOBILE_BREAKPOINT}px) {
    flex-direction: column-reverse;
  }
`;

const HeroHeaderTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
  padding: 24px;
`;

const BestOfWoltText = styled(Typography.Heading2)`
  display: inline;
  color: ${colors.wolt100};
`;

const BannerImage = styled.img.attrs({
  src: Banner,
})`
  height: 150px;

  @media (width < 1024px) {
    flex: 1;
  }
`;

const BannerMobileImage = styled.img.attrs({
  src: BannerMobile,
})`
  height: 190px;
`;

const CrossIcon = styled(Cross)`
  fill: ${cbSemanticCssVars.textSecondary};
  width: 12px;
  height: 12px;
  cursor: pointer;
  position: absolute;
  top: 12px;
  right: 12px;
`;

export const HeroHeader = () => {
  const [isBestOfWoltHeaderEnabled, setIsBestOfWoltHeaderEnabled] = useLocalStorage('best-of-wolt-header', 'true');
  const shouldShowHeroHeader = isBestOfWoltHeaderEnabled === 'true';
  const isMobile = useIsMobile();

  return shouldShowHeroHeader ? (
    <HeroHeaderContainer>
      <HeroHeaderTextContainer>
        <Typography.Heading2>
          <FormattedMessage
            id="best-of-wolt.hero.title"
            values={{
              suffix: (
                <BestOfWoltText>
                  <FormattedMessage id="best-of-wolt.hero.suffix" />
                </BestOfWoltText>
              ),
            }}
          />
        </Typography.Heading2>
        <Typography.Body2>
          <FormattedMessage id="best-of-wolt.hero.description" />
        </Typography.Body2>
      </HeroHeaderTextContainer>
      {isMobile ? <BannerMobileImage /> : <BannerImage />}
      <CrossIcon onClick={() => setIsBestOfWoltHeaderEnabled('false')} />
    </HeroHeaderContainer>
  ) : null;
};
